import { isAfter } from 'date-fns';
import { SimData } from 'src/common/components/Sim/constants/sim';

type useLastSessionInfoProps = {
  primarySimEntry: SimData | null;
  secondarySimEntry: SimData | null;
};

export const useLastSessionInfo = ({
  primarySimEntry,
  secondarySimEntry,
}: useLastSessionInfoProps) => {
  let simWithLastSession = null;
  let simNameWithLastSession = null;

  if (
    primarySimEntry?.sessionStatusLastUpdated &&
    primarySimEntry?.sessionStatusLastUpdated !== '-' &&
    secondarySimEntry?.sessionStatusLastUpdated &&
    secondarySimEntry?.sessionStatusLastUpdated !== '-'
  ) {
    const isPrimaryTimestampAfterSecondary = isAfter(
      new Date(primarySimEntry.rawData.sessionStatusLastUpdated!),
      new Date(secondarySimEntry.rawData.sessionStatusLastUpdated!),
    );

    simWithLastSession = isPrimaryTimestampAfterSecondary ? primarySimEntry : secondarySimEntry;
    simNameWithLastSession = isPrimaryTimestampAfterSecondary ? 'Primary' : 'Secondary';
  } else if (primarySimEntry?.sessionStatusLastUpdated !== '-') {
    simWithLastSession = primarySimEntry;
    simNameWithLastSession = 'Primary';
  } else if (secondarySimEntry?.sessionStatusLastUpdated !== '-') {
    simWithLastSession = secondarySimEntry;
    simNameWithLastSession = 'Secondary';
  }

  return {
    simWithLastSession,
    simNameWithLastSession,
  };
};
